import 'whatwg-fetch';
import Constants from '../model/AppConfiguration';
import StatusCodes from '../model/StatusCodes';
import PassengerConverter from '../converter/PassengerDetailConverter';
import ResponseError from './ResponseError';
import Request from './Request';
import convert from 'xml-js';

export default {
  getPassengerDetails,
  savePassengerDetails,
};

function getPassengerDetails (passengerId, reservationId) {
  reservationId = reservationId || 0;
  let currentMillis = new Date().getTime();
  let url = `${
    Constants.BASE_URL
  }?fuseaction=airres.getContactDetails&timestamp=${currentMillis}&reservationid=${reservationId}&contact_objectid=${passengerId}`;

  return fetch(url, Request.getBase())
    .then(response =>
      response
        .text()
        .then(response => {
          let responseData = convert.xml2json(response, { compact: true, spaces: 4 });

          responseData = JSON.parse(responseData);
          responseData = responseData ? responseData.result : responseData;

          let status =
            responseData && responseData.status && responseData.status._text ?
              parseInt(responseData.status._text, 10) :
              StatusCodes.UNKNOWN_ERROR;
          if (status === StatusCodes.UNKNOWN_ERROR) {
            return ResponseError.responseError(responseData);
          }
          return {
            status: status,
            data: PassengerConverter.passengerWireToInt(responseData.data),
          };
        })
        .catch(error => ResponseError.responseError(error))
    )
    .catch(error => ResponseError.responseError(error));
}

function savePassengerDetails (passenger, general) {
  let reservationId = general && general.reservationId ? general.reservationId : 0;
  let currentMillis = new Date().getTime();
  let url = `${
    Constants.BASE_URL
  }?fuseaction=airres.ActionSwitch&timestamp=${currentMillis}&reservationId=${reservationId}`;

  let body = PassengerConverter.passengerIntToWire(passenger, general);
  body = convert.json2xml(body, { compact: true, spaces: 4 });
  return fetch(url, Request.postBase(body))
    .then(response =>
      response
        .text()
        .then(response => {
          let responseData = convert.xml2json(response, { compact: true, spaces: 4 });

          responseData = JSON.parse(responseData);
          responseData = responseData ? responseData.result : responseData;

          let status =
            responseData && responseData.status && responseData.status._text ?
              parseInt(responseData.status._text, 10) :
              StatusCodes.UNKNOWN_ERROR;
          if (status === StatusCodes.UNKNOWN_ERROR) {
            return ResponseError.responseError(responseData);
          }
          return {
            status: status,
            data: PassengerConverter.passengerWireToInt(responseData.data),
          };
        })
        .catch(error => ResponseError.responseError(error))
    )
    .catch(error => ResponseError.responseError(error));
}



// WEBPACK FOOTER //
// ./src/remoting/PassengerRemoting.js